import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { BaseComponent } from '@library-shared/base/base.component';
import { DxSelectBoxComponent } from 'devextreme-angular';
import moment from 'moment';

@Component({
    selector: 'app-filter-date-select',
    templateUrl: './filter-date-select.component.html',
    styleUrls: ['./filter-date-select.component.scss'],
    standalone: false
})
export class FilterDateSelectComponent extends BaseComponent implements OnInit {
    @ViewChild('dateselect', { static: true })
    dateSelect: DxSelectBoxComponent;

    @Input()
    startDate: Date;
    @Output()
    startDateChange = new EventEmitter<Date>();

    @Input()
    stopDate: Date;
    @Output()
    stopDateChange = new EventEmitter<Date>();

    @Input() showUseDate = false;

    @Input()
    useDate = true;
    @Output()
    useDateChange = new EventEmitter<boolean>();

    @Output()
    dateFilterChanged = new EventEmitter<DateSelectFilter>();

    @Input()
    validationGroup: string;

    @Input()
    disabled: boolean;

    @Input()
    disableDropDown: boolean;

    QuickDateValue: string = null;
    quickDateList = [
        { name: 'Today', value: 'TD' },
        { name: 'Yesterday', value: 'YD' },
        { name: 'Last 3 Days', value: 'L3' },
        { name: 'Last 7 Days', value: 'L7' },
        { name: 'Last 30 Days', value: 'L30' },
        { name: 'Month to Date', value: 'MTD' },
        { name: 'Previous Month', value: 'PM' },
        { name: 'Next Week from Date', value: 'NWD' },
        { name: 'Next 3 Days from Date', value: 'N3D' },
        { name: 'Next Month from Date', value: 'NMD' },
        { name: 'Next 3 Months from Date', value: 'N3MD' },
        { name: 'Last 3 Months to Date', value: 'L3MTD' },
        { name: 'Last 6 Months to Date', value: 'L6MTD' },
        { name: 'Last 12 Months to Date', value: 'L12MTD' },
        { name: 'Year to Date', value: 'YTD' },
        { name: 'Previous Year', value: 'PY' },
    ];

    constructor() {
        super();
    }

    ngOnInit() {}

    onDateChange(e: any): void {
        //this.log.d('onDateChange', e);
        this.startDateChange.emit(this.startDate);
        this.stopDateChange.emit(this.stopDate);
        this.dateFilterChanged.emit({ startDate: this.startDate, stopDate: this.stopDate });
    }

    onQuickDateChange(e: any): void {
        if (!this.QuickDateValue) {
            return;
        }

        switch (this.QuickDateValue) {
            case 'TD':
                this.startDate = new Date();
                this.stopDate = new Date();
                break;
            case 'YD':
                this.startDate = moment().add(-1, 'days').toDate();
                this.stopDate = moment().add(-1, 'days').toDate();
                break;
            case 'L3':
                this.startDate = moment().add(-2, 'days').toDate();
                this.stopDate = moment().toDate();
                break;
            case 'L7':
                this.startDate = moment().add(-6, 'days').toDate();
                this.stopDate = moment().toDate();
                break;
            case 'L30':
                this.startDate = moment().add(-30, 'days').toDate();
                this.stopDate = moment().toDate();
                break;
            case 'MTD':
                this.startDate = moment().startOf('month').toDate();
                this.stopDate = moment().toDate();
                break;
            case 'PM':
                this.startDate = moment().add(-1, 'months').startOf('month').toDate();
                this.stopDate = moment().add(-1, 'months').endOf('month').toDate();
                break;
            case 'NMD':
                this.startDate = moment().toDate();
                this.stopDate = moment().add(30, 'days').toDate();
                break;
            case 'N3MD':
                this.startDate = moment().toDate();
                this.stopDate = moment()
                    .add(30 * 3, 'days')
                    .toDate();
                break;
            case 'L3MTD':
                this.startDate = moment()
                    .add(30 * 3 * -1, 'days')
                    .toDate();
                this.stopDate = moment().toDate();
                break;
            case 'L6MTD':
                this.startDate = moment()
                    .add(30 * 6 * -1, 'days')
                    .toDate();
                this.stopDate = moment().toDate();
                break;
            case 'L12MTD':
                this.startDate = moment()
                    .add(30 * 12 * -1, 'days')
                    .toDate();
                this.stopDate = moment().toDate();
                break;
            case 'YTD':
                this.startDate = moment().startOf('year').toDate();
                this.stopDate = moment().toDate();
                break;
            case 'PY':
                this.startDate = moment().add(-1, 'years').startOf('year').toDate();
                this.stopDate = moment().add(-1, 'years').endOf('year').toDate();
                break;
            case 'N3D':
                this.startDate = moment().toDate();
                this.stopDate = moment().add(3, 'days').toDate();
                break;
            case 'NWD':
                this.startDate = moment().toDate();
                this.stopDate = moment().add(1, 'weeks').toDate();
                break;
        }
        this.QuickDateValue = null;
        this.dateSelect.instance.reset();
        this.useDate = true;

        this.startDateChange.emit(this.startDate);
        this.stopDateChange.emit(this.stopDate);
        this.dateFilterChanged.emit({ quickFilter: true, startDate: this.startDate, stopDate: this.stopDate });
    }
}

export class DateSelectFilter {
    quickFilter? = false;
    startDate?: Date;
    stopDate?: Date;
}
